import { render } from "./Pack.vue?vue&type=template&id=6efddd4c"
import script from "./Pack.vue?vue&type=script&lang=js"
export * from "./Pack.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__